module.exports = __webpack_public_path__ + "static/media/fdva.570fad16.jpg";